// extracted by mini-css-extract-plugin
export default {"homeContainer":"homeV2_homeContainer__v4Idg","heroStack":"homeV2_heroStack__Duixy","paintbrushBand":"homeV2_paintbrushBand__EYRGT","paintbrushImg":"homeV2_paintbrushImg__a2Ucm"};